import {useQuery} from "react-query";
import {UserModel} from "./UserModel";
import {getAxios} from "../../axios/generic-api-calls";

export function useFetchUser(key:string = 'user') {
    return useQuery<UserModel>(
        key,
        () => getAxios('/user'),
        {
            retry: false
        }
    );
}
